import { createContext } from 'react';

import { ReportConfig } from '@app-velocity/common';
import {
  TAiReviewDto,
  TAiSimulationsFullSummaryDto,
  TAiUnifiedReviewDto,
} from '@app-velocity/av-api-v2';
import { PrototypeStatistics } from '@app-velocity/modules/simulation-report';

export type UserSimulationWidgetContextType = {
  parsedStatus: TAiReviewDto['reviewStatus'] | null;
  teamId?: string;
  workspaceId?: string;
  scenarioId?: string;
  shareToken?: string;
  latestReview?: TAiUnifiedReviewDto | null;
  summary?: TAiSimulationsFullSummaryDto | null;
  statistics?: PrototypeStatistics | null;
  config?: ReportConfig;
};

export const UserSimulationWidgetContext =
  createContext<UserSimulationWidgetContextType>({
    parsedStatus: null,
    teamId: '',
    workspaceId: '',
    scenarioId: '',
  });
